import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import CCText from '@/Atoms/CCText';
import ProfileAsset from '../ui/ProfileAsset';

const styles = StyleSheet.create({
  // Design's brown nudge banner (Caissa + copy + gold "Log in"), sitting below
  // the faded Overview teaser.
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 18,
    backgroundColor: '#4D3F37',
    borderRadius: 16,
    paddingVertical: 20,
    paddingHorizontal: 24,
    marginBottom: 16,
  },
  textCol: {flex: 1, minWidth: 200},
  title: {fontSize: 14.5, fontWeight: '600', color: '#fff'},
  subtitle: {fontSize: 12.5, color: 'rgba(255,255,255,0.65)', marginTop: 2},
  loginBtn: {
    backgroundColor: '#FACF47',
    borderRadius: 32,
    paddingVertical: 11,
    paddingHorizontal: 20,
  },
  loginBtnText: {fontSize: 12.5, fontWeight: '700', color: '#4D3F37'},
});

type Props = {
  name?: string | null;
  onLogin: () => void;
};

// Inline nudge (LinkedIn-style), not a modal or forced redirect -- rendered
// once below the faded Overview teaser, per docs/player-profile-plan.md's
// "Login nudge UX" note. Matches the design's brown Caissa banner.
export default function TeaserNudgeBanner({name, onLogin}: Props) {
  const who = name ? `${name}'s` : "this player's";
  return (
    <View style={styles.banner} testID="teaser-nudge-banner">
      <ProfileAsset name="caissaGirl" width={46} height={46} />
      <View style={styles.textCol}>
        <CCText style={styles.title}>Want to see {who} full game history?</CCText>
        <CCText style={styles.subtitle}>
          Log in to view Games, Training, Clubs and challenge them directly.
        </CCText>
      </View>
      <Pressable
        testID="teaser-nudge-login"
        style={styles.loginBtn}
        onPress={onLogin}>
        <CCText style={styles.loginBtnText}>Log in</CCText>
      </Pressable>
    </View>
  );
}
